import React, { useState } from "react";

// Logo files live in public/logos. Keys are institution short codes.
const LOGO_BY_CODE = {
  SMVEC: "smvec.png",
  SMVECU: "smvec.png",
  SMVECSOAS: "smvec.png",
  SMVECAHS: "smvec.png",
  SMVECCOLE: "smvec.png",
  SMVSAS: "smvec.png",
  SMVMCH: "smvmch.png",
  SMVSPH: "smv-super-speciality.png",
  SMVS: "smv-school.png",
  SMVNC: "smvnc.png",
  MVIT: "mvit.png",
  MEC: "mailam.png",
  TAKEC: "takshashila.png",
  TAKU: "takshashila.png",
  TAKMC: "takshashila.png",
};

// Used when only the institution name is available (events, deliveries).
const LOGO_BY_NAME = [
  ["takshashila", "takshashila.png"],
  ["mailam", "mailam.png"],
  ["mvit", "mvit.png"],
  ["nursing", "smvnc.png"],
  ["super speciality", "smv-super-speciality.png"],
  ["smvmch", "smvmch.png"],
  ["smv school", "smv-school.png"],
  ["smv", "smvec.png"],
];

export function institutionLogo({ short_code, name } = {}) {
  const code = short_code?.trim().toUpperCase();
  let file = code && LOGO_BY_CODE[code];
  if (!file && name) {
    const lower = name.toLowerCase();
    file = LOGO_BY_NAME.find(([key]) => lower.includes(key))?.[1];
  }
  return file ? `${process.env.PUBLIC_URL}/logos/${file}` : null;
}

export function institutionInitials({ short_code, name } = {}) {
  if (short_code) return short_code.slice(0, 3).toUpperCase();
  return (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

export default function InstitutionLogo({
  institution,
  name,
  size = 36,
  className = "",
}) {
  const subject = institution || { name };
  const src = institutionLogo(subject);
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };

  if (src && !failed) {
    return (
      <span className={`institution-logo ${className}`} style={style}>
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      </span>
    );
  }
  return (
    <span
      className={`institution-logo institution-logo-fallback ${className}`}
      style={style}
      aria-hidden="true"
    >
      {institutionInitials(subject) || "?"}
    </span>
  );
}
